// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pz1C19N5N1MQR4JTcNnk{justify-content:space-between;align-items:center;gap:12px;display:flex}.Pz1C19N5N1MQR4JTcNnk .ZrqNQqhXOekGWsEPXl5P{gap:8px;display:flex}.Pz1C19N5N1MQR4JTcNnk .ZrqNQqhXOekGWsEPXl5P .xa3y0rM9lYi6eLsuruWK{flex-direction:column;gap:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Pz1C19N5N1MQR4JTcNnk`,
	"left": `ZrqNQqhXOekGWsEPXl5P`,
	"column": `xa3y0rM9lYi6eLsuruWK`
};
export default ___CSS_LOADER_EXPORT___;
